const PAGE_CREATE_SUB_PAGE = "new";

export function isDceEditorRoute({ area, page, subPage }) {
  if (area !== "destinations" || !subPage) {
    return false;
  }
  if (page === "pages") {
    return subPage !== PAGE_CREATE_SUB_PAGE;
  }
  return page === "components";
}
